export { default } from './visually-hidden'
export type { Props as VisuallyHiddenProps } from './visually-hidden'
